import React, { useEffect, useRef, useState } from "react";
import Layouts from "layouts/Layouts";
import AppRouter from "./appRouter"; // Router


function App() {
    // const vConsole = new VConsole();
 
  return (
    <Layouts>
      <AppRouter />
    </Layouts>
  );
}

export default App;
